import React, {useEffect, useMemo} from 'react';
import * as css from './WhatsAppScreen.css.js';
import {updateWhatsAppMessage, updateEmailStatus, saveWhatsAppImage, updateDesignEmail} from '../../../redux/branding/brandingActions';
import ModeBtn from '../../../component/modeBtn/ModeBtn';
import WhatsAppTemplateEditor from '../../../component/whatsAppTemplateEditor/WhatsAppTemplateEditor';
import {useSelector} from 'react-redux';
import WhatsAppImage from './WhatsAppImage.js';
import {IS_NEW_TEMPLATE} from '../../../config/config';
import {updateEventSettings} from '../../../redux/event/eventActions';
import {setCurrentRating} from '../../components/rating/Rating';
import {TState} from '../../../redux/store.type';
import {TBranding} from '../../../redux/branding/branding.type';
import {useBrandingParams} from '../../../hooks/useBrandingParams';
import TrialPop from '../../../component/sendingPopup/components/trialPop/TrialPop';
import {useTranslation} from 'react-i18next';
import useGlobalShow from '../../../hooks/useGlobalShow.js';
import {TextTemplateItem} from '../../../component/whatsAppTemplateEditor/types/templateStructure';
import {serializeTemplateStructure, whatsappContentToTemplateStructure} from '../../../component/whatsAppTemplateEditor/utils/formatUtils';
import Loading from '../../mailing/Shared/Loading/Loading.js';

function WhatsAppScreen() {
    const {eid, defaultLang} = useSelector((s: TState) => ({
        eid: s.event.eid,
        defaultLang: s.event.lang
    }));
    const {messageType}=useBrandingParams();
    const {currentLang,data,getBrandingData} = useSelector((s: TState) => s.branding??{} as TBranding);
    const {whatsappContent,enabledWhatsapp}=data?.[currentLang]?.[messageType]??{};
    const dependencies=[currentLang,getBrandingData[`${currentLang}XHR`], messageType];
    const image = data?.[currentLang]?.[messageType]?.whatsappImage || data?.[defaultLang]?.whatsappImage;
    const newService = IS_NEW_TEMPLATE(Number(eid));
    const show = useGlobalShow('isOpenTrialPop');
    const trialPopupShow = useGlobalShow('isOpenTrialPopup');
    const saveWhatsAppImageXHR = useSelector((s: TState) => s.branding.saveWhatsAppImageFullXHR);

    const {t} = useTranslation('whatsapp');

    const updateStatus = async () => {
        await updateEmailStatus('enabledWhatsapp', (enabledWhatsapp || 0) === 1 ? 0 : 1, messageType);
        await updateEventSettings('whatsAppMessage', {active: (enabledWhatsapp || 0) === 1 ? false : true, messageType, lang: currentLang}, 'ticketsMailing');
    };

    const saveText = (valuesArray: TextTemplateItem[]) => {
        if(newService){ // || isDesperateMessage || isBillingMessage
            // For new template, desperate, or billing messages, save to eventWhatsappMessage table
            updateWhatsAppMessage(valuesArray, messageType, null);
        } else {
            const content = serializeTemplateStructure(valuesArray);
            updateDesignEmail(messageType, {whatsappContent:content, content, mailingType: 'whatsapp'});
        }
        
    };
    
    const messageContent = useMemo(() => {
        return newService
            ? serializeTemplateStructure(whatsappContent ?? [])
            : whatsappContent;
    }, [whatsappContent]);

    useEffect(() => {
        if(newService){
            setCurrentRating('whatsappNewService');
        }
    }, []);
    const templateStructure = useMemo(() => {
        return newService
            ? whatsappContent
            : whatsappContentToTemplateStructure(whatsappContent);
    }, [whatsappContent]);
    
    const isLoading = getBrandingData?.[`${currentLang}XHR`] !== 'SUCCESS';
    
    return (
        <css.wrapper data-cy={'whatsAppScreen'}>
            <css.top>
                {t('whatsappMailing')}
                <ModeBtn className={'small'} status={enabledWhatsapp} click={updateStatus} requestStatus={undefined} dataTitle={undefined} text={undefined} dataCyName={undefined}/>
            </css.top>
            <WhatsAppImage name="whatsappImage" eyeName="whatsappImage" image={image} saveImage={(image)=>saveWhatsAppImage(image, messageType)} imageXHR={saveWhatsAppImageXHR}/>
            {isLoading || !templateStructure ? (
                <Loading />
            ) : (
                <WhatsAppTemplateEditor
                    data-cy={'whatsAppTemplateEditor'}
                    templateStructure={templateStructure}
                    dependencies={dependencies}
                    events={{onSave: saveText}}
                />
            )}
            {show.isOpen && (
                <TrialPop
                    show={show}
                    messageContent={messageContent}
                    contactType="phone"
                    messageText={messageContent}
                    imagePath={image?.path || ''}
                    messageType={messageType}
                    currentLang={currentLang}
                    trialPopupShow={trialPopupShow}
                />
            )}
        </css.wrapper>
    );
}

export default WhatsAppScreen;
